export const miscEnvironment = {
  userLocalStorageKey: 'currentUser',
};
